import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { isMobileViewport } from '@/utils/viewport'
import { trackPageView } from '@/utils/googleAnalytics'
Vue.use(VueRouter)

const MOBILE_NOTICE_PATH = '/mobile-not-supported'

const routes = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: MOBILE_NOTICE_PATH,
    name: 'MobileDesktopNotice',
    meta: { requiresAuth: false, allowMobile: true, routeTitle: 'Desktop Required' },
    component: () => import(/* webpackChunkName: "mobile-notice" */ '../views/MobileDesktopNotice.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: { requiresAuth: false, routeTitle: 'Login' },
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/report/:id',
    name: 'PredixPublicReport',
    meta: { requiresAuth: false, allowMobile: true, routeTitle: 'PrediX Report' },
    component: () => import(/* webpackChunkName: "predix-report" */ '../views/user/iPredix/PredixPublicReport.vue')
  },
  {
    path: '/exports',
    redirect: '/panel/exports'
  },
  {
    path: '/change-password',
    name: 'ChangePasswordPage',
    meta: { requiresAuth: true, routeTitle: 'Change Password' },
    component: () => import(/* webpackChunkName: "changePasswordPage" */ '../views/user/ChangePasswordPage.vue')
  },
  {
    path: '/panel/profile',
    redirect: '/change-password'
  },
  {
    path: '/panel/profile/changepassword',
    redirect: '/change-password'
  },
  {
    path: '/panel',
    name: 'Panel',
    redirect: '/user/home',
    component: () => import(/* webpackChunkName: "users" */ '../views/user/Panel.vue'),
    meta: { requiresAuth: true, routeTitle: 'Panel' },
    children:[
      {
        path: '/panel/exports',
        name: 'ExportsList',
        meta: { requiresAuth: true, routeTitle: 'Exports' },
        component: () => import(/* webpackChunkName: "exports-list" */ '../views/user/ExportsList.vue')
      },
      {
        path: '/user/datasets',
        name: 'Datasets',
        meta: { requiresAuth: true, routeTitle: 'Datasets' },
        component: () => import(/* webpackChunkName: "users" */ '../views/user/Datasets.vue')
      },
      {
        path: '/user/home',
        name: 'Home',
        meta: { requiresAuth: true, routeTitle: 'Digital Tools' },
        component: () => import(/* webpackChunkName: "users" */ '../views/user/Home.vue')
      },
      
      {
        path: '/panel/predix',
        name: 'PredixCastingPlatform',
        meta: { requiresAuth: true, routeTitle: 'PrediX™' },
        component: () => import(/* webpackChunkName: "manageuser" */ '../views/user/iPredix/PredixCasting.vue'),
        // children: [
        //   {
        //     path: '/panel/predix/alloyproperties',
        //     name: 'AlloyProperties',
        //     meta: { requiresAuth: true, routeTitle: 'Alloy Properties' },
        //     component: () => import(/* webpackChunkName: "alloyproperties" */ '../views/user/casting/AlloyProperties.vue'),
        //   },
        //   // {
        //   //   path: '/panel/castingplatform/alloyproperties2',
        //   //   name: 'AlloyProperties2',
        //   //   meta: { requiresAuth: true, routeTitle: 'Alloy Properties2' },
        //   //   component: () => import(/* webpackChunkName: "alloyproperties2" */ '../views/user/casting/AlloyProperties2.vue'),
        //   // },
        //   {
        //     path: '/panel/castingplatform/benchmarking',
        //     name: 'Benchmarking',
        //     meta: { requiresAuth: true, routeTitle: 'Benchmarking Properties Against Standard Alloys' },
        //     component: () => import(/* webpackChunkName: "alloyproperties" */ '../views/user/casting/Benchmarking.vue'),
        //   }
        // ]
      },
      {
        path: '/panel/predix/casting',
        redirect: '/panel/predix',
      },
      {
        path: '/panel/predix/wrought',
        redirect: '/panel/predix',
      },
      {
        path: '/panel/ipredix',
        redirect: '/panel/predix',
      },
      {
        path: '/panel/ipredix/casting',
        redirect: '/panel/predix',
      },
      {
        path: '/panel/ipredix/wrought',
        redirect: '/panel/predix',
      },
      {
        path: '/panel/module-info/:id',
        name: 'LockedModuleInfo',
        meta: { requiresAuth: true, routeTitle: 'Overview' },
        component: () => import(/* webpackChunkName: "lockedmoduleinfo" */ '../views/user/LockedModuleInfo.vue'),
      },
      {
        path: '/panel/htdesign',
        redirect: '/panel/module-info/heatnx',
      },
      {
        path: '/panel/htDesign/*',
        redirect: '/panel/module-info/heatnx',
      },
      {
        path: '/panel/alloyDesign/*',
        redirect: '/panel/module-info/alloynx',
      },
      {
        path: '/panel/amplatform',
        name: 'AmPlatform',
        meta: { requiresAuth: true, routeTitle: 'AM Platform' },
        component: () => import(/* webpackChunkName: "manageam" */ '../views/user/am/ManageAm.vue'),
        children: [
          // {
          //   path: '/panel/castingplatform/alloyproperties',
          //   name: 'AlloyProperties',
          //   meta: { requiresAuth: true, routeTitle: 'Alloy Properties' },
          //   component: () => import(/* webpackChunkName: "alloyproperties" */ '../views/user/casting/AlloyProperties.vue'),
          // }
        ]
      },
      {
        path: '/panel/aimodel',
        name: 'AiModel',
        meta: { requiresAuth: true, routeTitle: 'AI Model Development' },
        component: () => import(/* webpackChunkName: "manageai" */ '../views/user/ai/ManageAi.vue'),
        children: [
          // {
          //   path: '/panel/castingplatform/alloyproperties',
          //   name: 'AlloyProperties',
          //   meta: { requiresAuth: true, routeTitle: 'Alloy Properties' },
          //   component: () => import(/* webpackChunkName: "alloyproperties" */ '../views/user/casting/AlloyProperties.vue'),
          // }
        ]
      },
    ]
  },
  {
    path: '/admin',
    name: 'AdminHome',
    component: () => import(/* webpackChunkName: "users" */ '../views/admin/Home.vue'),
    meta: { requiresAuth: true, routeTitle: 'Admin' },
    children:[
      {
        path: '/admin/users',
        name: 'Users',
        meta: { requiresAuth: true, routeTitle: 'Users' },
        component: () => import(/* webpackChunkName: "users" */ '../views/admin/user/Users.vue')
      },
      {
        path: '/admin/users/:id',
        name: 'ManagerUser',
        meta: { requiresAuth: true, routeTitle: 'ManagerUser' },
        component: () => import(/* webpackChunkName: "manageuser" */ '../views/admin/user/ManageUser.vue'),
        children: [
          {
            path: '/admin/users/:id/info',
            name: 'userInfo',
            meta: { requiresAuth: true, routeTitle: 'User Profile' },
            component: () => import(/* webpackChunkName: "userinfo" */ '../views/admin/user/UserInfo.vue'),
          },
          {
            path: '/admin/users/:id/datasets',
            name: 'userDatasets',
            meta: { requiresAuth: true, routeTitle: 'User Databases' },
            component: () => import(/* webpackChunkName: "userdatasets" */ '../views/admin/user/UserDatasets.vue'),
          },
          {
            path: '/admin/users/:id/grantaccess',
            name: 'grantDatasets',
            meta: { requiresAuth: true, routeTitle: 'Grant Access to Databases' },
            component: () => import(/* webpackChunkName: "userdatasets" */ '../views/admin/user/GrantDatasets.vue'),
          }
        ]
      },
      {
        path: '/admin/databases',
        name: 'Datasets',
        meta: { requiresAuth: true, routeTitle: 'Databases' },
        component: () => import(/* webpackChunkName: "databases" */ '../views/admin/dataset/Datasets.vue')
      },
      {
        path: '/admin/settings',
        name: 'Settings',
        meta: { requiresAuth: true, routeTitle: 'Settings' },
        component: () => import(/* webpackChunkName: "settings" */ '../views/admin/Settings.vue'),
        children: [
          {
            path: '/admin/settings/columngroups',
            name: 'columnGroups',
            meta: { requiresAuth: true, routeTitle: 'Column Groups' },
            component: () => import(/* webpackChunkName: "columngroups" */ '../views/admin/settings/ColumnGroups.vue')
          },
          {
            path: '/admin/settings/general',
            name: 'generalSettings',
            meta: { requiresAuth: true, routeTitle: 'General Settings' },
            component: () => import(/* webpackChunkName: "generalsettings" */ '../views/admin/settings/General.vue')
          }
        ]
      },
      {
        path: '/admin/profile',
        name: 'Profile',
        meta: { requiresAuth: true, routeTitle: 'Profile' },
        component: () => import(/* webpackChunkName: "profile" */ '../views/admin/profile/ManageProfile.vue'),
        children: [
          {
            path: '/admin/profile/changepassword',
            name: 'changePassword',
            meta: { requiresAuth: true, routeTitle: 'Change Password' },
            component: () => import(/* webpackChunkName: "changePassword" */ '../views/admin/profile/ChangePassword.vue')
          }
        ]
      },
      {
        path: '/admin/databases/:id',
        name: 'ManageDataset',
        meta: { requiresAuth: true, routeTitle: 'Manage Databases' },
        component: () => import(/* webpackChunkName: "managedatabases" */ '../views/admin/dataset/ManageDataset.vue'),
        children:[
          {
            path: '/admin/databases/:id/info',
            name: 'datasetInfo',
            meta: { requiresAuth: true, routeTitle: 'Database Information' },
            component: () => import(/* webpackChunkName: "datasetinfo" */ '../views/admin/dataset/DatasetInfo.vue')
          },
          {
            path: '/admin/databases/:id/upload',
            name: 'datasetUpload',
            meta: { requiresAuth: true, routeTitle: 'Upload Database' },
            component: () => import(/* webpackChunkName: "datasetinfo" */ '../views/admin/dataset/DatasetUpload.vue')
          },
          {
            path: '/admin/databases/:id/columns',
            name: 'datasetColumns',
            meta: { requiresAuth: true, routeTitle: 'Upload Database' },
            component: () => import(/* webpackChunkName: "datasetinfo" */ '../views/admin/dataset/DatasetColumns.vue')
          },
          {
            path: '/admin/databases/:id/analyze',
            name: 'analyzeDataset',
            meta: { requiresAuth: true, routeTitle: 'Analyze Database' },
            component: () => import(/* webpackChunkName: "datasetinfo" */ '../views/admin/dataset/AnalyzeDataset.vue')
          },
        ]
      }
    ]
  },

]

const router = new VueRouter({
  routes
})



router.beforeEach((to, from, next) => {
  if (to.path === MOBILE_NOTICE_PATH && !isMobileViewport()) {
    const fallback = store.state.Login ? '/user/home' : '/login'
    const target = from.path && from.path !== MOBILE_NOTICE_PATH ? from.path : fallback
    next(target)
    return
  }

  const allowMobile = to.matched.some((record) => record.meta.allowMobile)
  if (!allowMobile && isMobileViewport()) {
    next({ path: MOBILE_NOTICE_PATH })
    return
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const auth = store.state.Login
    if (!auth) {
      store.commit('logout')
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      // check if user has access to this route
      const path = to.path
      if (path.startsWith('/admin') && store.state.isStaff === false )
      {
        store.commit('logout')
        next({ path: '/login', query: { redirect: to.fullPath } })
      }
      else{
        document.title = 'MetalNx: ' + to.meta.routeTitle
        next()
      }
      // const token = store.state.Token
      // const method = 'get'
      // const project = 'pid' in to.params ? to.params.pid : null
      // postaccess(project, token, method, path, function (res) {
      //   if (res.hasAccess === true) {
      //     // --
      //     // this is temprory , check if user is demo then force to search page only
      //     // --
      //     if (store.state.UserEmail.includes('demo')) {
      //       if (!to.path.includes('catalogs')) { next({ path: '/catalogs' }) }
      //       if (to.params.id && !to.path.includes('/search')) { next({ path: '/catalogs/' + to.params.id + '/search' }) }
      //     }
      //     document.title = 'DolphinAI : ' + to.meta.routeTitle
      //     next()
      //   } else {
      //     next({ path: '/restricted' })
      //   }
      // }, function () {
      //   // error checking access , force logout
      //   store.commit('logout')
      //   next({ path: '/login', query: { redirect: to.fullPath } })
      // })
    }
  } else {
    document.title = 'MetalNx : ' + to.meta.routeTitle
    next()
  }
})

router.afterEach((to) => {
  const title = to.meta.routeTitle
    ? `MetalNx: ${to.meta.routeTitle}`
    : document.title
  trackPageView(to.fullPath, title)
})

export default router
